import type { HomeTab } from "./homeBrowserTypes";

export interface HomeEmptyCopy {
  title: string;
  hint?: string;
}

/**
 * Two-line empty state per tab (house convention). `scoped` swaps the org-wide
 * hints for workspace-scoped ones — on a workspace page "Files you create or
 * upload appear here" reads as a claim about the whole account.
 */
export function homeEmptyCopy(tab: HomeTab, scoped = false): HomeEmptyCopy {
  switch (tab) {
    case "recents":
      return {
        title: "No files yet",
        hint: scoped
          ? "Drop a file anywhere on this page to upload it here"
          : "Files you create or upload appear here",
      };
    case "canvases":
      return {
        title: "No canvases yet",
        hint: "Create a canvas from the box above or + New",
      };
    case "library":
      return {
        title: "Nothing here yet",
        hint: "Create a canvas or drop a file to upload it here",
      };
    case "chats":
      return {
        title: "No chats yet",
        hint: "Start a conversation from the box above",
      };
    case "starred":
      return {
        title: "Nothing in favorites yet",
        hint: scoped
          ? "Add a canvas or file in this workspace to favorites and it stays here"
          : "Add a canvas or file to favorites and it stays here",
      };
    case "shared":
      return {
        title: "Nothing shared with you yet",
        hint: "Files people share directly with you appear here",
      };
  }
}
